import { createFileRoute } from '@tanstack/react-router';
import { AgendaPage } from '@/domains/collections';

export const Route = createFileRoute('/_backoffice/collections/agenda')({
    component: AgendaPage,
});
